import { __assign } from "tslib";
import classNames from 'classnames';
import React from 'react';
import styles from './checkbox.module.css';
import { capitalize } from '../../../library';
export var Checkbox = React.forwardRef(function (props, ref) {
    var _a, _b, _c;
    var 
    // HTML props
    id = props.id, _d = props.checked, checked = _d === void 0 ? false : _d, _e = props.disabled, disabled = _e === void 0 ? false : _e, 
    // custom props
    children = props.children, _f = props.clickablearea, clickablearea = _f === void 0 ? 'label' : _f, _g = props.alignitems, alignitems = _g === void 0 ? 'flex-start' : _g, _h = props.hidelabeloverflow, hidelabeloverflow = _h === void 0 ? false : _h;
    var nativeProps = __assign(__assign({}, props), { children: undefined, clickablearea: undefined, alignitems: undefined, hidelabeloverflow: undefined });
    return (React.createElement("div", { className: classNames(styles.baseCheckboxOuter, styles.checkboxOuter, (_a = {}, _a[styles.disabled] = disabled, _a)) },
        React.createElement("input", __assign({ type: "checkbox" }, nativeProps, { ref: ref, checked: checked, className: classNames(styles["clickableArea".concat(capitalize(clickablearea))]) })),
        React.createElement("div", { className: styles.baseCheckboxInner, style: { alignItems: alignitems }, onClick: function (event) { return event.preventDefault(); } },
            React.createElement("div", { className: classNames(styles.baseCheckboxElement, (_b = {}, _b[styles.checked] = checked, _b[styles.disabled] = disabled, _b)) }),
            React.createElement("label", { className: classNames(styles.checkboxContent, (_c = {}, _c[styles.hideLabelOverflow] = hidelabeloverflow, _c)), htmlFor: id }, children))));
});
Checkbox.displayName = 'Checkbox';
export default Checkbox;
